import React from "react";
import AppShell from "@/components/layout/AppShell";
import EquipmentLoansPanel from "./EquipmentLoansPanel";

export default function EquipmentLoans() {
  return (
    <AppShell variant="admin" title="Equipment Loans">
      <EquipmentLoansPanel />
    </AppShell>
  );
}
